import { Box, Dialog, SwipeableDrawer, useMediaQuery, useTheme } from '@mui/material';
import DrawerContent from './DrawerContent';

export interface TermsProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  type: 'Purchase' | 'Compliance';
}



export const TermsModal = ({ open, onOpen, onClose, type }: TermsProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? (
    <SwipeableDrawer
      PaperProps={{ square: false }}
      sx={{
        '& .MuiDrawer-paper': {
          borderRadius: '30px 30px 0 0',
        },
      }}
      anchor="bottom"
      onOpen={onOpen}
      onClose={onClose}
      open={open}
    >
      <Box m={4} mx={2} mb={1}>
        <DrawerContent type={type} onClose={onClose}/>
      </Box>
    </SwipeableDrawer>
  ) : (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      onClose={onClose}
      open={open}
      PaperProps={{
        style: { borderRadius: 20 },
      }}
    >
      <Box m={4}>
        <DrawerContent type={type} onClose={onClose}/>
      </Box>
    </Dialog>
  );
};
